// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "fe_static/css/" + chunkId + "." + "d24d466d" + ".chunk.css";
};